import { render, staticRenderFns } from "./the-7-day-self-talk-challenge.vue?vue&type=template&id=631d197a&"
import script from "./the-7-day-self-talk-challenge.vue?vue&type=script&lang=js&"
export * from "./the-7-day-self-talk-challenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports